import { usePaginatePatientsByOrganization } from 'api/resource';
import { Patient } from 'interfaces';
import { MRT_ColumnFiltersState, MRT_SortingState } from 'mantine-react-table';
import { useState } from 'react';
import { useCurrentSiteStore } from 'store/SiteStore';

export const useUserPatientManagementData = () => {
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
    globalFilter: '',
    columnFilters: [] as MRT_ColumnFiltersState,
    sorting: [] as MRT_SortingState,
  });

  const { organizationID } = useCurrentSiteStore();
  const patientResult = usePaginatePatientsByOrganization({
    organizationID,
    page: pagination.pageIndex,
    pageSize: pagination.pageSize,
    columnFilters: pagination.columnFilters,
    globalFilter: pagination.globalFilter,
    sorting: pagination.sorting,
  });
  const patients = patientResult.data?.data || ([] as Patient[]);
  const total = patientResult.data?.total || 0;
  const nextPage = patientResult.data?.nextPage || 0;

  const isLoading = patientResult.isLoading;
  const isError = patientResult.isError;
  const isFetching = patientResult.isFetching;
  const refetchPatients = patientResult.refetch;
  const errorMessage = patientResult.error?.message;

  return {
    patients,
    total,
    nextPage,
    isLoading,
    isError,
    isFetching,
    refetchPatients,
    errorMessage,
    pagination,
    setPagination,
  };
};
